<template>
  <div class="main-view" style="overflow: auto;">
    <div>
      <div style="margin-bottom: 10px">客户开票流程</div>
      <el-table
        :data="table1"
        style="margin-bottom: 10px"
        border
        :header-cell-style="{ background: '#f5f5f5' }"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="step_name" label="审批环节" align="center">
        </el-table-column>
        <el-table-column prop="admin_name" label="审批人" align="center">
          <template slot-scope="scope">
            <span style="margin-right: 10px">{{ scope.row.admin_name }}</span>
            <span>{{ scope.row.account }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="update_time" label="更新时间" align="center">
        </el-table-column>
        <el-table-column prop="action" label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)"
              >修改审核人</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-bottom: 10px">供应商付款流程</div>
      <el-table
        :data="table2"
        style="margin-bottom: 10px"
        border
        :header-cell-style="{ background: '#f5f5f5' }"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="step_name" label="审批环节" align="center">
        </el-table-column>
        <el-table-column prop="admin_name" label="审批人" align="center">
          <template slot-scope="scope">
            <span style="margin-right: 10px">{{ scope.row.admin_name }}</span>
            <span>{{ scope.row.account }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="update_time" label="更新时间" align="center">
        </el-table-column>
        <el-table-column prop="action" label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)"
              >修改审核人</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <edit ref="editRef" @refresh="init()"></edit>
  </div>
</template>

<script>
import { mixinTable } from "@/mixins/table.js";
import edit from "./components/edit";

export default {
  components: {
    edit,
  },
  mixins: [mixinTable],
  data() {
    return {
      table1: [],
      loading1: false,
      table2: [],
      loading2: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getTable1();
      this.getTable2();
    },
    getTable1() {
      this.loading1 = true;
      this.$http
        .get("/admin/approval/config", { params: { type: 1 } })
        .then((res) => {
          if (res.code === 1) {
            this.table1 = res.data.list;
          }
        })
        .finally(() => {
          this.loading1 = false;
        });
    },
    getTable2() {
      this.loading2 = true;
      this.$http
        .get("/admin/approval/config", { params: { type: 2 } })
        .then((res) => {
          if (res.code === 1) {
            this.table2 = res.data.list;
          }
        })
        .finally(() => {
          this.loading2 = false;
        });
    },
    handleEdit(row) {
      let dom = this.$refs.editRef;
      dom.toggle(true);
      dom.getDetail(row);
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .el-badge__content.is-fixed {
  right: 18px !important;
}
.action-row {
  margin-top: 10px;
  display: flex;
}
.margin-right6 {
  margin-right: 6px;
}
.margin-top-10 {
  margin-top: 10px;
}
.isGreen {
  color: #f59a23;
}
</style>